/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.languages.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.languages = {};
proto.witbooking.backoffice.languages.v1 = require('./languages_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.languages.v1.LanguagesAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.languages.v1.LanguagesAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.languages.v1.GetLanguagesRequest,
 *   !proto.witbooking.backoffice.languages.v1.GetLanguagesResponse>}
 */
const methodDescriptor_LanguagesAPI_GetAllLanguages = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.languages.v1.LanguagesAPI/GetAllLanguages',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.languages.v1.GetLanguagesRequest,
  proto.witbooking.backoffice.languages.v1.GetLanguagesResponse,
  /**
   * @param {!proto.witbooking.backoffice.languages.v1.GetLanguagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.languages.v1.GetLanguagesRequest,
 *   !proto.witbooking.backoffice.languages.v1.GetLanguagesResponse>}
 */
const methodInfo_LanguagesAPI_GetAllLanguages = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.languages.v1.GetLanguagesResponse,
  /**
   * @param {!proto.witbooking.backoffice.languages.v1.GetLanguagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.languages.v1.GetLanguagesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.languages.v1.GetLanguagesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.languages.v1.LanguagesAPIClient.prototype.getAllLanguages =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.languages.v1.LanguagesAPI/GetAllLanguages',
      request,
      metadata || {},
      methodDescriptor_LanguagesAPI_GetAllLanguages,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.languages.v1.GetLanguagesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.languages.v1.LanguagesAPIPromiseClient.prototype.getAllLanguages =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.languages.v1.LanguagesAPI/GetAllLanguages',
      request,
      metadata || {},
      methodDescriptor_LanguagesAPI_GetAllLanguages);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.languages.v1.GetLanguageRequest,
 *   !proto.witbooking.backoffice.languages.v1.GetLanguageResponse>}
 */
const methodDescriptor_LanguagesAPI_GetLanguage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.languages.v1.LanguagesAPI/GetLanguage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.languages.v1.GetLanguageRequest,
  proto.witbooking.backoffice.languages.v1.GetLanguageResponse,
  /**
   * @param {!proto.witbooking.backoffice.languages.v1.GetLanguageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.languages.v1.GetLanguageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.languages.v1.GetLanguageRequest,
 *   !proto.witbooking.backoffice.languages.v1.GetLanguageResponse>}
 */
const methodInfo_LanguagesAPI_GetLanguage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.languages.v1.GetLanguageResponse,
  /**
   * @param {!proto.witbooking.backoffice.languages.v1.GetLanguageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.languages.v1.GetLanguageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.languages.v1.GetLanguageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.languages.v1.GetLanguageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.languages.v1.LanguagesAPIClient.prototype.getLanguage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.languages.v1.LanguagesAPI/GetLanguage',
      request,
      metadata || {},
      methodDescriptor_LanguagesAPI_GetLanguage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.languages.v1.GetLanguageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.languages.v1.LanguagesAPIPromiseClient.prototype.getLanguage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.languages.v1.LanguagesAPI/GetLanguage',
      request,
      metadata || {},
      methodDescriptor_LanguagesAPI_GetLanguage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest,
 *   !proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse>}
 */
const methodDescriptor_LanguagesAPI_UpdateLanguage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.languages.v1.LanguagesAPI/UpdateLanguage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest,
  proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse,
  /**
   * @param {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest,
 *   !proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse>}
 */
const methodInfo_LanguagesAPI_UpdateLanguage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse,
  /**
   * @param {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.languages.v1.LanguagesAPIClient.prototype.updateLanguage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.languages.v1.LanguagesAPI/UpdateLanguage',
      request,
      metadata || {},
      methodDescriptor_LanguagesAPI_UpdateLanguage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.languages.v1.LanguagesAPIPromiseClient.prototype.updateLanguage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.languages.v1.LanguagesAPI/UpdateLanguage',
      request,
      metadata || {},
      methodDescriptor_LanguagesAPI_UpdateLanguage);
};


module.exports = proto.witbooking.backoffice.languages.v1;

